export enum ApiEndPoint {
  loginApi = '/login/',
  logoutApi = '/logout/',
  sendOtp = '/send/otp/',
  verifyOtp = '/verify-otp/',
  sendOtpForVerification = '/send-otp-mfa/',
  twoFactorValidation = '/varify-two-factor-verification/',
  registration = '/access/register_account',
  logedInUser = '/user/me',
  InvoiceApi = '/billing/invoice/',
  RazorPayOrderApi = '/billing/invoice/{id}/payment/create_razorpay_order/',
  State = '/geo/states/',
  accountVerify = '/access/verify',
  resetPassword = '/change/password/',
  verifyResetPassword = '/access/update_password/',
  Account = '/account/',
  UserList = '/user/',
  UserRoleList = '/user/role',
  Stamp = '/inventory/physical_stamp/',
  StampDenomination = '/inventory/denomination',
  // VerifyOTP = '/access/verify_otp',
  ResendOTP = '/access/resend_otp',
  reportSummary = '/report/summary/',
  reportCount = '/report/report_count/',
  reportFullDetail = '/report/full_report/',
  getUserInfo = '/user/',
  cyberArkToken = '/cyberark-login/',
}
